import React from "react";


export default function ShowTotalCart({ carrito }) {
  const total = carrito.reduce((acum, p) => {
    acum += p.cantidad * p.price;
    return acum;
  }, 0);
  return <div >{`$${total}`}</div>;
}
